import React, { useState } from 'react';
import VoxelPanel from '../../../components/voxel/Surfaces/VoxelPanel';
import VoxelHorPanelTab from '../../../components/voxel/Tabs/VoxelHorPanelTab';
import VoxelHorTabContainer from '../../../components/voxel/Tabs/VoxelHorTabContainer';
import { CurrentUserGq } from '../../../graphql/users/models/CurrentUserGq';
import { PagingInputGq } from '../../../graphql/users/models/PagingInputGq';
import { usersApiService } from '../../../graphql/users/usersApiService';
import ExistingMembersTable from './ExistingMembersTable';
import PendingInvitationsTable from './PendingInvitationsTable';
import RemovedMembersTable from './RemovedMembersTable';

export interface MembersTableProps {
  reload?: () => Promise<unknown>;
  currentUser: CurrentUserGq;
  currentTab: MemberChoices;
  setCurrentTab: React.Dispatch<React.SetStateAction<MemberChoices>>;
}
export enum MemberChoices {
  Members = 'Team members',
  Pending = 'Pending invitations',
  Removed = 'Removed',
}

const TabList = [
  { id: MemberChoices.Members, title: 'Team members', tooltip: '' },
  {
    id: MemberChoices.Pending,
    title: 'Pending invitations',
    tooltip: 'Invites that has not signed in',
  },
  { id: MemberChoices.Removed, title: 'Removed members', tooltip: 'Removed users' },
];

export const MembersTable: React.FC<MembersTableProps> = ({
  reload,
  currentUser,
  currentTab,
  setCurrentTab,
}) => {
  // Get team users
  const [paging, setPaging] = useState<PagingInputGq>({ page: 0, amountPerPage: 20 });
  const {
    query,
    users: teamMembers,
    paging: pagingResult,
  } = usersApiService.queries.useGetTeamUsers({
    pagingInput: paging,
    searchTerm: '',
    members: currentTab === MemberChoices.Members,
    removed: currentTab === MemberChoices.Removed,
    pending: currentTab === MemberChoices.Pending,
  });

  // Logic
  if (!teamMembers) return null;
  return (
    <div>
      <VoxelHorTabContainer>
        {TabList.map((bt) => (
          <VoxelHorPanelTab
            key={bt.id}
            onClick={() => setCurrentTab(TabList.find((l) => l.id === bt.id).id)}
            active={currentTab === bt.id}
            title={bt.title}
            tooltip={bt.tooltip}
          />
        ))}
      </VoxelHorTabContainer>
      <VoxelPanel className={'t rounded-tl-none'}>
        {currentTab === MemberChoices.Members && (
          <ExistingMembersTable
            paging={paging}
            setPaging={setPaging}
            pagingResult={pagingResult}
            members={teamMembers}
            currentUser={currentUser}
            reload={reload}
          />
        )}
        {currentTab === MemberChoices.Pending && (
          <PendingInvitationsTable
            paging={paging}
            setPaging={setPaging}
            pagingResult={pagingResult}
            users={teamMembers}
            currentUser={currentUser}
            reload={reload}
          />
        )}
        {currentTab === MemberChoices.Removed && (
          <RemovedMembersTable
            paging={paging}
            setPaging={setPaging}
            pagingResult={pagingResult}
            users={teamMembers}
            currentUser={currentUser}
            reload={reload}
          />
        )}
      </VoxelPanel>
    </div>
  );
};

export default MembersTable;
